export enum AttachmentType {
    RESOURCE = 1,
    IMAGE = 2,
    VIDEO = 3
}